import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./list-item.module.css";
export var ListItem = function(param) {
    var label = param.label, href = param.href, ariaLabel = param.ariaLabel, handleClickEvent = param.handleClickEvent, apiData = param.apiData;
    return /*#__PURE__*/ _jsx("a", {
        href: href,
        "aria-label": ariaLabel,
        className: styles.listItem,
        onClick: handleClickEvent,
        children: "".concat(label, " ").concat(apiData ? "(".concat(apiData, ")") : "")
    });
};
